const langtrans={
      sgjjgg:["事故经过：","Details of accident:"],
      cxdd:["出险地-国家：","Location-country："],
      cxdd1:["出险地-城市：","Location-city："],
      cxdd2:["出险地-详细地址：","Location-addr："],
      sglx:["事故类型：","Type of accident:"],
      ssbw:["受伤部位：","Injured part:"],
      tqzh:["天气灾害：","Climate disaster:"],
      wm:["无","None"],
}
export default langtrans;



// WEBPACK FOOTER //
// ./src/views/commonPage/details/js/Parinf.vue.trans.js